import { render, staticRenderFns } from "./spuGroup.vue?vue&type=template&id=28610c60&scoped=true"
import script from "./spuGroup.vue?vue&type=script&lang=js"
export * from "./spuGroup.vue?vue&type=script&lang=js"
import style0 from "./spuGroup.vue?vue&type=style&index=0&id=28610c60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28610c60",
  null
  
)

export default component.exports